import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { LinkValue, RedirectPageConfig } from '@front-platform/content-builder';
import { redirectPageResolveConfig } from '@front-platform/content-builder';
import { Component, inject, OnInit, input } from '@angular/core';
import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';
import { LinkNavigationService } from '@core/services/link-navigation/link-navigation.service';

export interface RedirectPageRuntimeConfig {}

export type RedirectPageConfigInput = Partial<
  Omit<RedirectPageConfig, keyof RedirectPageRuntimeConfig> & RedirectPageRuntimeConfig
>;
export type RedirectPageResolvedConfig = Omit<RedirectPageConfig, keyof RedirectPageRuntimeConfig> &
  Partial<RedirectPageRuntimeConfig>;
export interface RedirectPageContract extends ConfigComponentContract<
  RedirectPageConfigInput,
  RedirectPageResolvedConfig
> {}

type RedirectTarget = string | LinkValue;

@Component({
  selector: 'app-redirect-page',
  template: ``,
  standalone: false,
})
export class RedirectPageComponent implements OnInit, RedirectPageContract {
  private readonly cb2PreviewState = inject(Cb2PreviewStateService);
  private readonly linkNavigation = inject(LinkNavigationService);

  readonly config = input<RedirectPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<RedirectPageConfig, RedirectPageRuntimeConfig>(
    redirectPageResolveConfig,
    () => ({ config: this.config() }),
  );

  ngOnInit(): void {
    if (this.cb2PreviewState.isActive()) {
      return;
    }

    const redirectTo = this.resolvedConfig()['redirect_to'] as unknown as
      RedirectTarget | undefined;
    if (redirectTo == null || (typeof redirectTo === 'string' && !redirectTo.trim())) {
      this.linkNavigation.navigate('/');
      return;
    }

    this.linkNavigation.navigate(redirectTo);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(RedirectPageComponent, { 'keyAliases': {} });
